"use client";
import { useState } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Logo from "../../assets/logo.svg";
import { Link } from "react-router-dom"; // Import Link from react-router-dom

const navigation = [
  { name: "Home", href: "/" },
  { name: "About Us", href: "/about" },
  { name: "Contact Us", href: "/contact" },
  { name: "Gallery", href: "/gallery" },
];

const Navbar = ({ solid = false }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header
      className={
        solid
          ? "sticky top-0 z-50 bg-[#0648BF] shadow-sm"
          : "absolute inset-x-0 top-0 z-50"
      }
    >
      <nav
        aria-label="Global"
        className={`flex items-center justify-between ${solid ? "py-4 px-6 lg:px-24" : "p-12 lg:px-24"}`}
      >
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="sr-only">CCC</span>
            <img
              alt="Company Logo"
              src={Logo}
              className={`${solid ? "md:h-14 h-9" : "md:h-20 h-8"} w-auto`}
            />
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className={`-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 ${solid ? "text-white" : "text-gray-400"}`}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
          </button>
        </div>
        <div className="hidden lg:flex lg:items-center lg:gap-x-12">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`text-xl font-pt-sans leading-6 ${solid ? "text-white hover:text-[#E6EEFF]" : "text-white"}`}
            >
              {item.name}
            </Link>
          ))}
        </div>
      </nav>
      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="lg:hidden"
      >
        <div className="fixed inset-0 z-50" />
        <DialogPanel
          className={`fixed inset-y-0 right-0 z-50 w-full overflow-y-auto px-6 py-6 sm:max-w-sm ${solid ? "bg-[#0648BF] sm:ring-1 sm:ring-white/20" : "bg-gray-900 sm:ring-1 sm:ring-white/10"}`}
        >
          <div className="flex items-center justify-between">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">CCC</span>
              <img alt="CCC" src={Logo} className="h-8 w-auto" />
            </Link>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className={`-m-2.5 rounded-md p-2.5 ${solid ? "text-white" : "text-gray-400"}`}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/25">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`-mx-3 block font-pt-sans rounded-lg px-3 py-2 text-base font-semibold leading-7 ${solid ? "text-white hover:bg-[#1A5CCC]" : "text-white hover:bg-gray-800"}`}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
};

export default Navbar;
